import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge de classes Tailwind com dedupe (bg-x depois bg-y => bg-y). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
